module.exports = require("aws-sdk");